import config from "../config";
import UserDAO from "./UserDAO";
import TokenDAO from "./TokenDAO";
import ColaboradorDAO from "./ColaboradorDAO";
import EncryptHelper from "../helpers/EncryptHelper";

export default class DAO {

	static get user() {
		return UserDAO;
	}

	static get token() {
		return TokenDAO;
	}

	static get colaborador() {
		return ColaboradorDAO;
	}

	static getProperty(prop) {
		const key = EncryptHelper.encryptKey(config.DAO.prefix + prop);
		let property = EncryptHelper.decrypt(localStorage.getItem(key));

		try {
			property = JSON.parse(property);
		} catch {
			return property;
		}

		return property;
	}

	static setProperty(prop, value) {
		const key = EncryptHelper.encryptKey(config.DAO.prefix + prop);

		if (typeof value !== "string") {
			value = JSON.stringify(value);
		}

		value = EncryptHelper.encrypt(value);
		localStorage.setItem(key, value);
	}

	static removeProperty(prop) {
		const key = EncryptHelper.encryptKey(config.DAO.prefix + prop);
		const property = EncryptHelper.decrypt(localStorage.getItem(key));

		if (property) {
			localStorage.removeItem(key);
		}
	}

	static clear() {
		localStorage.clear();
		UserDAO.set({
			rules: ["public"]
		});
	}
}
